export default "__VITE_ASSET__b2365bdf__"